const language_selected = 'en';

export default language_selected;